import React, {useState,useEffect} from "react";
import './App.css';
import PCUser from './PCUser';
import PhoneUser from "./PhoneUser";

function AppUser({match}) {
  const id = match.params.id;

  //const [PCUser_, setPCUser_] = useState(false); 

  const [PCUser_, setPCUser_] = useState(); 

  useEffect(()=>{
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
      setPCUser_(false); 
    }else{
      setPCUser_(true);
    }
  },[])  


  return (
    <div className="App">
      {PCUser_?(
        <>
        <PCUser ID={id}/>
        </>
      ):(
        <>
        <PhoneUser ID={id}/>
        </>
      )}

    </div>
  );
}

export default AppUser;
